<template>
  <CRow class="">
    <CCol sm="12" class="mb-5">
      <a @click="$router.go(-1)" class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer">
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2 text-uppercase" viewBox="0 0 32 32" />
        {{ $t('audience.customFields.button-back-to-audience') }}
      </a>
    </CCol>

    <CCol sm="12" class="mb-4">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>

    <CCol sm="12" class="mb-4 dataTable dataTable--customTypes">
      <CCardBody class="dataTable__body p-0">
        <CDataTable :items="types" :fields="fields" :items-per-page="itemsPerPage" hover cleaner :active-page="1">
          <template #value="{ item }">
            <td class="pl-5">
              <EditCellTable :cell="item" :types="types" @saveItem="getSelectTypes" @sendMenssage="setMenssage" />
            </td>
          </template>

          <template #personalizationTag="{ item }">
            <td class="pl-3 py-3">
              {{ item.personalizationTag }}
            </td>
          </template>

          <template #dataType="{ item }">
            <td class="pl-3 py-3">
              {{ item.dataType.value }}
            </td>
          </template>

          <template #createdDatetime="{ item }">
            <td class="pl-3 py-3">
              {{ item.createdDatetime ? formatDateTimeFull(new Date(item.createdDatetime).toISOString()) : '' }}
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCol>
  </CRow>
</template>

<script>
import { dateFormatStringFull } from '@/utils/dateUtil.js'
import services from '@/services.js'
import EditCellTable from '@/components/table/EditCellTable'
import MenssageAlert from '@/components/MenssageAlert'

const fields = [
  // {
  //   key: "key",
  //   label: "",
  //   _classes: "hidden",
  // },
  {
    key: 'value',
    label: 'Name',
    _classes: 'pl-5',
  },
  {
    key: 'personalizationTag',
    label: 'Personalization Tag',
  },
  {
    key: 'dataType',
    label: 'data Type',
  },
  {
    key: 'createdDatetime',
    label: 'Created',
  },
]

export default {
  name: 'CustomFields',
  components: { EditCellTable, MenssageAlert },

  data() {
    return {
      messages: [],
      loading: false,
      schema: [],
      fields,
      customTypes: [],
      itemsPerPage: 10000,
      organizationId: null,
    }
  },

  created() {
    this.organizationId = this.$store.state.auth.organizationId
    this.getSchema()
    this.getSelectTypes()
  },

  computed: {
    types() {
      const fieldsKeys = this.schema.filter((item) => item.isKey)
      let newArray = [...fieldsKeys, ...this.customTypes]
      return this.getUnique(newArray, 'key')
    },

    // organizationId() {
    //   return this.$store.state.auth.organizationId
    // }
  },

  methods: {
    formatDateTimeFull(date) {
      return dateFormatStringFull(date)
    },
    async getSchema() {
      this.messages = []
      this.loading = true
      try {
        let data = await services.audienceSchema(this.organizationId)
        this.schema = data.data.data.values
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message,
        })
        this.loading = false
      }
    },

    setMenssage(body) {
      this.messages = []
      this.messages.push(body)
    },

    getUnique(arr, comp) {
      return arr
        .map((e) => e[comp])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter((e) => arr[e])
        .map((e) => arr[e])
    },

    getSelectTypes() {
      this.loading = true
      this.messages = []
      services
        .fieldtypes(this.organizationId)
        .then((response) => {
          this.customTypes = response.data.data.groups.find((group) => group.types).types
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.dataTable {
  &--customTypes {
    td {
      padding: 0;
    }

    .addWrapperClasses {
      display: flex;
    }
  }
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
